import { ElementType, forwardRef, InputHTMLAttributes, ReactNode } from 'react';

import { cn } from '../../helpers/cn';

export type CoreInputProps = {
  label?: ReactNode;
  defaultValue?: string;
  inputClassName?: string;
  ExternalInputComponent?: ElementType;
} & InputHTMLAttributes<HTMLInputElement>;

// we extracted inout to separate component to be able to
// re-use between different input types (like tel and others)

export const CoreInput = forwardRef<HTMLInputElement, CoreInputProps>(
  (
    { id, type, label, ExternalInputComponent, inputClassName, ...props },
    ref
  ) => {
    if (ExternalInputComponent) {
      return (
        <ExternalInputComponent
          id={id}
          ref={ref}
          className={cn(
            // layout
            'peer placeholder:text-iron flex size-full px-0 pt-6 pb-2 focus:placeholder:opacity-100',
            // reset styles
            'box-border border-none outline-hidden file:border-0 file:bg-transparent',
            `body-16-regular disabled:bg-snow disabled:text-iron`,
            {
              'opacity-0': type === 'file',
              'py-0': !label,
              'placeholder:opacity-0': type !== 'tel',
            },
            inputClassName
          )}
          {...props}
        />
      );
    }

    return (
      <input
        id={id}
        type={type}
        className={cn(
          // layout
          'peer placeholder:text-iron flex size-full px-0 pt-6 pb-2 focus:placeholder:opacity-100',
          // reset styles
          'box-border border-none outline-hidden file:border-0 file:bg-transparent',
          `body-16-regular disabled:bg-snow disabled:text-iron`,
          {
            'opacity-0': type === 'file',
            'py-0': !label,
            'placeholder:opacity-0': type !== 'tel',
          },
          inputClassName
        )}
        ref={ref}
        {...props}
        value={props.value === null && type !== 'file' ? '' : props.value}
      />
    );
  }
);
